import React, { useEffect, useState } from 'react'
import { Button, Card, Title } from 'react-native-paper'
import { useDispatch, useSelector } from 'react-redux'

import Recipes from 'components/Recipes'
import { filterRecipes } from 'src/recipes'
import { setRecipes, swapRecipe } from 'src/redux/actions'

const MAX_MEALS = 5
const getRandomKey = (keys) => keys[Math.floor(Math.random() * keys.length)]

const MealSelect = ({ navigation: { navigate } }) => {
  const dispatch = useDispatch()
  const keys = useSelector(({ recipes: { keys } }) => keys)
  const { meals, diet } = useSelector(({ settings }) => settings)
  const [filteredKeys, setKeys] = useState(null)

  const loading = keys.length !== MAX_MEALS || !filteredKeys

  useEffect(() => {
    setKeys(filterRecipes(diet))
  }, [diet])

  useEffect(() => {
    if (filteredKeys && loading)
      dispatch(
        setRecipes(
          Array(MAX_MEALS)
            .fill()
            .map(() => getRandomKey(filteredKeys)),
        ),
      )
  }, [meals])

  if (loading) return null

  return (
    <Recipes
      onSwap={(index) =>
        dispatch(swapRecipe(index, getRandomKey(filteredKeys)))
      }
    >
      <Card.Title
        title="Meal Select"
        subtitle="choose your meals for the week"
      />
      <Card.Content>
        <Title>
          Swap you meals until you're happy. There's no ctrl+z so choose wisely
        </Title>
      </Card.Content>
      <Card.Actions>
        <Button onPress={() => navigate('Settings')} style={{ borderWidth: 0 }}>
          Filters & Settings
        </Button>
      </Card.Actions>
    </Recipes>
  )
}

export default MealSelect
